import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=7540ede3&scoped=true&"
import script from "./warehouse.vue?vue&type=script&lang=js&"
export * from "./warehouse.vue?vue&type=script&lang=js&"
import style0 from "./warehouse.vue?vue&type=style&index=0&id=7540ede3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7540ede3",
  null
  
)

export default component.exports